<template>
    <b-modal title="Create Template" id="order-template-modal" @ok="handleOk">
        <form class="my-3 py-3" @submit.stop.prevent="createTemplate">
            <b-form-group
                label="Name"
                label-for="order-template-name"
                label-class="font-weight-bold pt-0"
                label-cols="3"
            >
                <b-form-input
                    id="order-template-name"
                    placeholder="Enter the name of the order template"
                    v-model="model.order_template_name"
                    required
                >
                </b-form-input>
            </b-form-group>
            <b-form-group
                id="order_category_id-group"
                label="Category:"
                label-class="font-weight-bold pt-0"
                label-for="order_category_id"
                label-cols="3"
            >
                <b-form-select
                    id="order_category_id"
                    v-model="model.order_category_id"
                    required
                    :options="
                        categories.map(x => ({
                            value: x.id,
                            text: x.name,
                        }))
                    "
                >
                    <template #first>
                        <b-form-select-option :value="null" disabled
                            >Select Template Category</b-form-select-option
                        >
                    </template>
                </b-form-select>
            </b-form-group>
        </form>
        <template #modal-footer="{ ok, cancel }">
            <b-button size="sm" variant="secondary" @click="cancel()"
                >Cancel</b-button
            >

            <b-button size="sm" variant="primary" @click="ok()"
                >Create Template</b-button
            >
        </template></b-modal
    >
</template>

<script>
import popupMixins from '@/mixins/popupMixins'

export default {
    mixins: [popupMixins],
    data() {
        return {
            model: {
                order_category_id: null,
                order_template_name: null,
            },
        }
    },

    filters: {},
    created() {
        this.$store.dispatch('orderCategory/fetchAll')
    },
    mounted() {},
    watch: {
        order_template_id: function (val) {
            this.$emit('input', val)
        },
        'model.order_template_name': function (name) {
            this.model.order_template_name = name
            this.$emit('input', this.model)
        },
        'model.order_category_id': function (id) {
            this.model.order_category_id = id
            this.$emit('input', this.model)
        },
    },
    computed: {
        categories() {
            return this.$store.state.orderCategory.categories
        },
        order() {
            const item = this.$store.state.orders.item
            return item || {}
        },
    },

    methods: {
        showModal() {
            this.$bvModal.show('order-template-modal')
        },

        async createNewTemplate() {
            await this.$store.dispatch('orderTemplate/create', this.model)
        },

        handleOk(bvModalEvt) {
            // Prevent modal from closing
            bvModalEvt.preventDefault()
            // Trigger submit handler
            this.createTemplate()
        },

        async createTemplate() {
            try {
                const template = {
                    order_category_id: this.model.order_category_id,
                    name: this.model.order_template_name,
                    description: this.order.description,
                }
                const { id } = this.order
                const data = await this.$store.dispatch(
                    'orders/createTemplate',
                    {
                        id,
                        template,
                    }
                )
                this.$bvModal.hide('order-template-modal')
                this.doToast(
                    'Success',
                    'Activity template successfully created',
                    'success'
                )
                console.log(data)
            } catch (err) {
                const responseMessage = err.response.data.error.message
                let errorMessage = 'Unable to create order template. '
                console.log(err.response.data.error)

                // Check if the fields have not been set
                if (responseMessage.includes('cannot be null')) {
                    errorMessage +=
                        'Please set a name and select an order category for your template'

                    // Checks if the order template already exists
                } else if (responseMessage.includes('Duplicate entry')) {
                    errorMessage +=
                        'Name of Activity template already exists. Please select a new name'
                } else {
                    errorMessage += responseMessage
                }

                this.doToast('Error', errorMessage, 'danger')
            }
        },
    },
}
</script>
